import { apiClient } from "@/shared/api/client";
import type {
  CalendarResponse,
  SetExceptionPayload,
  SetTemplatePayload,
} from "@/features/availability/types";

export async function fetchCalendar(): Promise<CalendarResponse> {
  const { data } = await apiClient.get<CalendarResponse>("/availability/me");
  return data;
}

export async function replaceTemplate(payload: SetTemplatePayload): Promise<CalendarResponse> {
  const { data } = await apiClient.put<CalendarResponse>("/availability/me/template", payload);
  return data;
}

export async function setException(
  date: string,
  payload: SetExceptionPayload,
): Promise<CalendarResponse> {
  const { data } = await apiClient.put<CalendarResponse>(
    `/availability/me/exceptions/${date}`,
    payload,
  );
  return data;
}

export async function clearException(date: string): Promise<CalendarResponse> {
  const { data } = await apiClient.delete<CalendarResponse>(
    `/availability/me/exceptions/${date}`,
  );
  return data;
}
